import React from 'react';

// Shared factory for the inline SVG icon set: 24x24 stroked outlines that
// inherit color from their container. Individual icons may override viewBox
// or strokeWidth by passing them through `props`.
const base = (size, props) => ({
  xmlns: 'http://www.w3.org/2000/svg',
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  ...props,
});

export const IconPlus = ({ size = 14, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const IconSearch = ({ size = 14, ...props }) => (
  <svg {...base(size, props)}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </svg>
);

export const IconCheck = ({ size = 14, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M5 12l5 5L20 7" />
  </svg>
);

export const IconClose = ({ size = 12, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const IconChevronDown = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);

export const IconChevronRight = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M9 6l6 6-6 6" />
  </svg>
);

export const IconExternalLink = ({ size = 14, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M14 4h6v6" />
    <path d="M20 4l-9 9" />
    <path d="M19 14v5a1 1 0 01-1 1H5a1 1 0 01-1-1V6a1 1 0 011-1h5" />
  </svg>
);

export const IconMore = ({ size = 14, ...props }) => (
  <svg {...base(size, props)}>
    <circle cx="5" cy="12" r="2.6" fill="currentColor" stroke="none" />
    <circle cx="12" cy="12" r="2.6" fill="currentColor" stroke="none" />
    <circle cx="19" cy="12" r="2.6" fill="currentColor" stroke="none" />
  </svg>
);

export const IconInfoCircle = ({ size = 32, ...props }) => (
  <svg {...base(size, { ...props, viewBox: '0 0 32 32' })}>
    <path d="M16 21.3333V16M16 10.6666H16.0134M29.3334 16C29.3334 23.3638 23.3638 29.3333 16 29.3333C8.63622 29.3333 2.66669 23.3638 2.66669 16C2.66669 8.63616 8.63622 2.66663 16 2.66663C23.3638 2.66663 29.3334 8.63616 29.3334 16Z" />
  </svg>
);

export const IconCalendarCheck = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <rect x="3" y="4.5" width="18" height="16" rx="2.5" />
    <path d="M3 9h18" />
    <path d="M8 2.5v4M16 2.5v4" />
    <path d="M9 14.5l2 2 4-4" />
  </svg>
);

export const IconEdit = ({ size = 16, ...props }) => (
  <svg {...base(size, { ...props, viewBox: '0 0 16 16', strokeWidth: 1.2 })}>
    <path d="M7.99998 13.3333H14M2 13.3333H3.11636C3.44248 13.3333 3.60554 13.3333 3.75899 13.2965C3.89504 13.2638 4.0251 13.21 4.1444 13.1369C4.27895 13.0544 4.39425 12.9391 4.62486 12.7085L13 4.33334C13.5523 3.78106 13.5523 2.88563 13 2.33334C12.4477 1.78106 11.5523 1.78106 11 2.33334L2.62484 10.7085C2.39424 10.9391 2.27894 11.0544 2.19648 11.189C2.12338 11.3083 2.0695 11.4383 2.03684 11.5744C2 11.7278 2 11.8909 2 12.217V13.3333Z" />
  </svg>
);

export const IconTrash = ({ size = 16, ...props }) => (
  <svg {...base(size, { ...props, viewBox: '0 0 16 16', strokeWidth: 1.2 })}>
    <path d="M5.71596 1.14307H10.2874M1.14453 3.42878H14.8588M13.335 3.42878L12.8007 11.4435C12.7205 12.646 12.6804 13.2472 12.4207 13.7031C12.1921 14.1044 11.8472 14.4271 11.4315 14.6285C10.9594 14.8574 10.3568 14.8574 9.15165 14.8574H6.8517C5.64655 14.8574 5.04398 14.8574 4.57184 14.6285C4.15616 14.4271 3.81127 14.1044 3.58261 13.7031C3.3229 13.2472 3.28282 12.646 3.20265 11.4435L2.66834 3.42878" />
  </svg>
);

export const IconRefresh = ({ size = 14, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M20 11.5A8 8 0 006.3 6.3L3 9.5" />
    <path d="M4 12.5A8 8 0 0017.7 17.7L21 14.5" />
    <path d="M3 4.5v5h5M21 19.5v-5h-5" />
  </svg>
);

export const IconServer = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <rect x="3" y="3.5" width="18" height="7" rx="2" />
    <rect x="3" y="13.5" width="18" height="7" rx="2" />
    <path d="M7 7h.01M7 17h.01" />
  </svg>
);

export const IconGrip = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <circle cx="9" cy="6" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="15" cy="6" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="9" cy="12" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="15" cy="12" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="9" cy="18" r="1.4" fill="currentColor" stroke="none" />
    <circle cx="15" cy="18" r="1.4" fill="currentColor" stroke="none" />
  </svg>
);

export const IconArrowUp = ({ size = 12, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M12 20V4" />
    <path d="M6 10l6-6 6 6" />
  </svg>
);

export const IconArrowDown = ({ size = 12, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M12 4v16" />
    <path d="M6 14l6 6 6-6" />
  </svg>
);

export const IconLogout = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M17 16l4-4m0 0l-4-4m4 4H7" />
    <path d="M13 16v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
  </svg>
);

export const IconAlertTriangle = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M10.3 3.6L2.4 17a2 2 0 001.7 3h15.8a2 2 0 001.7-3L13.7 3.6a2 2 0 00-3.4 0z" />
    <path d="M12 9v4M12 17h.01" />
  </svg>
);

export const IconClock = ({ size = 14, ...props }) => (
  <svg {...base(size, props)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3.5 2" />
  </svg>
);

export const IconUpload = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M12 16V4" />
    <path d="M7 9l5-5 5 5" />
    <path d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2" />
  </svg>
);

export const IconSun = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </svg>
);

export const IconMoon = ({ size = 16, ...props }) => (
  <svg {...base(size, props)}>
    <path d="M21 12.8A9 9 0 1111.2 3a7 7 0 009.8 9.8z" />
  </svg>
);
